import { render, staticRenderFns } from "./curSale-order-delivery.vue?vue&type=template&id=2c7f5256&scoped=true"
import script from "./curSale-order-delivery.vue?vue&type=script&lang=js"
export * from "./curSale-order-delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f5256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7f5256')) {
      api.createRecord('2c7f5256', component.options)
    } else {
      api.reload('2c7f5256', component.options)
    }
    module.hot.accept("./curSale-order-delivery.vue?vue&type=template&id=2c7f5256&scoped=true", function () {
      api.rerender('2c7f5256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/curSale-management/curSale-order/curSale-order-delivery.vue"
export default component.exports